import { render } from "./FunFactCard.vue?vue&type=template&id=2fc4b2eb"
import script from "./FunFactCard.vue?vue&type=script&lang=js"
export * from "./FunFactCard.vue?vue&type=script&lang=js"

import "./FunFactCard.vue?vue&type=style&index=0&id=2fc4b2eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__